import { HomeworkAPI } from '../../path/homework';
import { fetchData } from '@umu/umu-fetch';
import { IResponse } from '@umu/umu-types';

export interface IOutput {
    result: boolean;
}

interface IInput {
    homework_id: number;
    is_excellent: number;
}

export const switchHomeworkExcellent = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(HomeworkAPI.POST_SWITCH_HOMEWORK_EXCELLENT, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
